import { useContext, useEffect, useState } from 'react'
import {
  CapitalHarnessContext,
  SET_SHOW_HIDE_COPY_POPUP,
} from '../context/context'

import { NavContext } from '../../../../../context/global_context'
import { useParams } from 'react-router-dom'
import Modal, { ModalBody, ModalHeader } from '../../../../common/Modal'
import SelectInput from '../../../../common/SelectInput'
import { getRequest } from '../../../../../services/base'
import LinkWithStatus from '../../../../common/LinkWithStatus'
import Button from '../../../../common/Button'
import { downloadFile } from '../../../../../utils/common'

const CloneDataFromPopup = () => {
  const { vehicle } = useParams()

  const [state, dispatch] = useContext(CapitalHarnessContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [vehicleOptions, setVehicleOptions] = useState([])
  const [selectedVehicle, setSelectedVehicle] = useState({})
  const [result, setResult] = useState({})
  const [showMessage, setShowMessage] = useState(
    'Please Select Make To Copy Data'
  )

  useEffect(() => {
    getVehicleList()
  }, [])

  const getVehicleList = async (search = '') => {
    let res = await getRequest(`/api/vehicles/?limit=50&search=${search}`)
    setVehicleOptions(res?.results)
  }

  const getMappingData = async (value) => {
    if (
      window.confirm(
        `Are you sure you want to ${state?.selectedType?.name} ${value.vehicle_id}`
      ) === true
    ) {
      setShowMessage(`Loading Data For ${state?.selectedType?.name}`)

      navDispatch({
        type: 'loader',
        data: {
          caption: `Copying Data from selected ${value.vehicle_id}`,
          showLoader: true,
        },
        notification: {},
      })
      let res = await getRequest(
        `/api/plugin/capital_harness/fetch_related_data/${value.vehicle_id}/?selectedId=${state?.selectedObject.id}&selectedType=${state?.selectedType?.value}`
      )
      if (res?.status) {
        setResult(res?.data)
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Copy Completed, Please check summary',
          },
        })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
      setShowMessage('')
    }
  }

  const downloadMissingFile = async (fileType, fileName) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Downloading Missing ${fileName} `,
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(
      `/api/plugin/capital_harness/download_file/?selectedId=${state?.selectedObject.id}&fileType=${fileType}`
    )
    if (res?.data?.missing_file) {
      downloadFile(res?.data?.missing_file, fileName)

      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `${fileName} Downloaded Successfully`,
        },
      })
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: 'Something went wrong',
        },
      })
    }
  }

  return (
    <Modal
      onClose={() => {
        dispatch({
          type: SET_SHOW_HIDE_COPY_POPUP,
          data: {},
          showCopyPopup: false,
          selectedType: {},
        })
      }}
      show={true}
      size={'w-3/4'}
    >
      <ModalHeader className={'text-white p-1'}>
        <div className="flex items-center justify-between">
          <div className="text-sm ">
            <div>{state?.selectedObject.name}</div>
          </div>

          <div className="text-sm flex items-end w-1/2">
            <SelectInput
              options={vehicleOptions}
              isRequired={true}
              label={`${state?.selectedType?.name} Vehicle`}
              onInputChange={(e) => {
                if (e) {
                  getVehicleList(e)
                }
              }}
              onChange={(value) => {
                setSelectedVehicle(value)
                getMappingData(value)
              }}
              optionLabel="name"
              optionValue="vehicle_id"
            />
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <div>
          <div className="text-center text-white">{showMessage}</div>
          {result?.status ? (
            <div className="text-center text-white py-2">{result?.msg} !</div>
          ) : (
            <div className="text-center text-red-400 py-2">{result?.msg}</div>
          )}
          {result?.wire?.missing?.length > 0 && (
            <div className="flex items-center justify-between bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
              <div>
                Total Missing Circuits - {result?.wire?.missing?.length}
              </div>
              <div>
                <LinkWithStatus
                  href={`/vehicles/${vehicle.vehicle_id}/download-missing-circuits`}
                  className="btn py-2 px-3 flex"
                  title="Download Missing Circuits"
                  onClickFunc={() => {
                    downloadMissingFile('0', `${vehicle}-missing-circuit.csv`)
                  }}
                  key={`download-missing-circuits`}
                ></LinkWithStatus>
              </div>
            </div>
          )}
          {result?.wire?.mapped?.length > 0 && (
            <div className="flex items-center justify-between bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
              <div>Total Mapped Circuits - {result?.wire?.mapped?.length}</div>
            </div>
          )}
          {result?.connector?.missing?.length > 0 && (
            <div className="flex items-center justify-between bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
              <div>
                Total Missing Devices - {result?.connector?.missing?.length}
              </div>
              <div>
                <LinkWithStatus
                  href={`/vehicles/${vehicle.vehicle_id}/download-missing-devices`}
                  className="btn py-2 px-3 flex"
                  title="Download Missing Devices"
                  onClickFunc={() => {
                    downloadMissingFile('1', `${vehicle}-missing-devices.csv`)
                  }}
                  key={`download-missing-devices`}
                ></LinkWithStatus>
              </div>
            </div>
          )}
          {result?.connector?.mapped?.length > 0 && (
            <div className="flex items-center justify-between bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
              <div>
                Total Mapped Devices - {result?.connector?.mapped?.length}
              </div>
              <div>
                <LinkWithStatus
                  href={`/vehicles/${vehicle.vehicle_id}/download-mapped-devices`}
                  className="btn py-2 px-3 flex"
                  title="Download Mapped Devices"
                  onClickFunc={() => {}}
                  key={`download-mapped-devices`}
                ></LinkWithStatus>
              </div>
            </div>
          )}
        </div>
        <div className="flex justify-end">
          <div className="w-auto">
            <Button
              type="button"
              className={`cursor-pointer btn my-4 w-full justify-end`}
              onClick={(e) => {
                dispatch({
                  type: SET_SHOW_HIDE_COPY_POPUP,
                  data: {},
                  showCopyPopup: false,
                  selectedType: {},
                })
              }}
              value={'text'}
              text={'Close'}
            />
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default CloneDataFromPopup
